import { render, staticRenderFns } from "./PcButton.vue?vue&type=template&id=1afc022f"
import script from "./PcButton.vue?vue&type=script&lang=js"
export * from "./PcButton.vue?vue&type=script&lang=js"
import style0 from "./PcButton.vue?vue&type=style&index=0&id=1afc022f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VList } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VList,VMenu})
